import { formatPercentage } from "@signolteam/shared/units-of-measure";
import React from "react";
import PropTypes from "prop-types";
import AppUtils from "@src/utils/appUtils";

/**
 * Returns the text in a container with primary-700 text colour, primary-100 background and primary-300 border.
 */
export const HelpText = (props) => {
  const { children } = props;
  return (
    <div className="w-auto text-sm text-primary-700 bg-primary-100 rounded-lg p-4 text-left border border-primary-300">
      {children}
    </div>
  );
};

/**
 * Returns either a dynamic social proof sentence or a commitment percentage based on commitment data.
 * @param {Function} getDynamicContent - Dynamic content resolver - set as null to only return the number
 * @param {string} commitment - Commitment key
 * @param {Array} customerCommitments - Array of commitments
 * @param {Object} customer - Customer object with name
 */
export const getSocialProofSentence = (
  getDynamicContent,
  commitment,
  customerCommitments,
  customer,
) => {
  const commitmentData = customerCommitments?.find(
    (c) => c.commitment === commitment,
  );
  if (!commitmentData) return null;

  const {
    customerCount,
    customerPercentage,
    industryCount,
    industryPercentage,
  } = commitmentData;

  if (customerPercentage > 50) {
    return getDynamicContent
      ? getDynamicContent(
          "captain__commitments__social_proof__within_customer",
          {
            CUSTOMER_COUNT: customerCount,
            CUSTOMER_PERCENTAGE: formatPercentage(
              "0-100",
              customerPercentage,
              null,
              { precisionOverride: 0 },
            ).formattedValue,
          },
        )
      : formatPercentage("0-100", customerPercentage, null, {
          precisionOverride: 0,
        }).formattedValue;
  }

  if (industryCount > 1) {
    return getDynamicContent
      ? getDynamicContent(
          "captain__commitments__social_proof__within_industry",
          {
            INDUSTRY_COUNT: industryCount,
            INDUSTRY_PERCENTAGE: formatPercentage(
              "0-100",
              industryPercentage,
              null,
              { precisionOverride: 0 },
            ).formattedValue,
          },
        )
      : formatPercentage("0-100", industryPercentage, null, {
          precisionOverride: 0,
        }).formattedValue;
  }

  return null;
};
